/**
 * Abrir uma ficha (processo ou cliente) a partir do menu, da busca global ou da Home.
 *
 * O processo abre pelo mesmo caminho que o CRM já usa (`processoParaAbrir` no
 * store da interface), e a lista de processos mostra a ficha. O cliente abre
 * pela lista de clientes com `?cliente=<id>`, que o módulo de Clientes lê.
 */
import { useNavigate } from 'react-router-dom';
import { useUIStore } from '../../store/uiStore';

export function useAbrirFicha() {
  const navigate = useNavigate();
  const setProcessoParaAbrir = useUIStore((s) => s.setProcessoParaAbrir);

  return (tipo, registro) => {
    if (!registro) return;
    if (tipo === 'processo') {
      setProcessoParaAbrir(registro);
      navigate('/juridico');
    } else if (tipo === 'cliente') {
      navigate(`/crm?cliente=${encodeURIComponent(registro.id)}`);
    }
  };
}
